import React,{useEffect} from "react";
import "./ShippingPolicy.css";
// import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";

const ShippingPolicy = () => {
   useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // ya "auto"
    });
  }, []);

  return (
    <div className="shipping-policy">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Shipping Policy", isActive: true },
        ]}
      />
      <main className="shipping-policy__main">
        <div className="shipping-policy__container">
          <div className="shipping-policy__content">
            <p className="shipping-policy__intro">
              At Yug Mantra, we aim to deliver your products safely and on time. This Shipping Policy outlines our shipping timelines, charges, and other related terms so you know what to expect when you place an order with us.
            </p>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Processing Time</h2>
              <ul className="shipping-policy__list">
                <li>Orders are typically processed within 1-2 working days.</li>
                <li>During high-demand periods, processing may take an additional 1-2 days.</li>
              </ul>
            </div>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Estimated Delivery Time</h2>
              <ul className="shipping-policy__list">
                <li>Within India: 3-7 business days after dispatch.</li>
                <li>Metro cities typically receive deliveries faster than remote locations.</li>
              </ul>
            </div>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Shipping Charges</h2>
              <ul className="shipping-policy__list">
                <li>Shipping charges, if applicable, are shown at checkout before payment.</li>
                <li>Occasional free-shipping promotions may apply as per offer terms.</li>
              </ul>
            </div>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Order Tracking</h2>
              <p>
                Once your order is dispatched, you will receive a tracking link via SMS or email. You can also view your order status in the My Orders section after logging in.
              </p>
            </div>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Undeliverable or Delayed Shipments</h2>
              <ul className="shipping-policy__list">
                <li>If a shipment is returned due to incorrect address or repeated delivery attempts, we may contact you to re-ship; additional charges may apply.</li>
                <li>Delays caused by courier partners, weather, or local restrictions are outside our control but we will assist wherever possible.</li>
              </ul>
            </div>

            <div className="shipping-policy__section">
              <h2 className="shipping-policy__section-title">Contact Us</h2>
              <p>If you have questions regarding shipping, please reach out:</p>
              <div className="shipping-policy__contact">
                <p><strong>Phone:</strong> +91-7490026756</p>
                <p><strong>Email:</strong> siddharthfashion1037@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default ShippingPolicy;